import React from 'react'
import Bone from 'pobble-components/dist/bone'

const UserSkeleton = () => {
  return (
    <div>
      <Bone
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '100%',
          margin: '0 auto',
          display: 'block'
        }}
      />
      <div>
        <Bone
          style={{
            width: '100px',
            height: '12px',
            borderRadius: '4px',
            margin: '13px auto 40px',
            display: 'block'
          }}
        />
      </div>
    </div>
  )
}

export default UserSkeleton
